const API_KEY = '673db94496875681';

export default class PacketaPlaceSelector {

    constructor(element) {
        this.element = element;
        this.country = element.dataset.country;
        this.language = element.dataset.placeSelectorLanguage;
        this.branchName = element.querySelector('[data-packeta-place-selector-result]');
        this.branchId = element.querySelector('[data-packeta-place-selector-input]');

        this.element.addEventListener('click', () => this.open());
    }

    open() {
        if (typeof Packeta === 'undefined') {
            return;
        }

        Packeta.Widget.pick(
            API_KEY,
            (pudo) => this.onPicked(pudo),
            {
                country: this.country,
                language: this.language,
            },
        );
    }

    onPicked(pudo) {
        if (pudo === null) {
            this.branchName.innerText = this.branchName.dataset.emptyText;
            this.branchId.value = '';
            return;
        }

        this.branchName.innerText = pudo.name;
        this.branchId.value = pudo.id;
    }

    static init(container) {
        container.querySelectorAll('[data-packeta-place-selector]').forEach((element) => {
            new PacketaPlaceSelector(element);
        });
    }

}

naja.addEventListener('init', () => {
    PacketaPlaceSelector.init(document.body);
});

naja.snippetHandler.addEventListener('afterUpdate', (event) => {
    PacketaPlaceSelector.init(event.detail.snippet);
});
